import { useTranslation } from 'react-i18next';
import PhoneVerificationForm from '@/components/Forms/PhoneVerificationForm';
import { useValidatePhoneNumber } from '@/query/queries/user/useValidatePhoneNumber';
import s from './index.module.scss';

const PhoneVerificationModal = ({
  phone,
  captchaToken,
  getCaptchaToken,
  onClose,
  onBack,
  onSuccess,
}) => {
  const { mutateAsync: validatePhoneNumber} = useValidatePhoneNumber();
  const { t } = useTranslation('auth');

  const onSubmit = async (values, { setErrors }) => {
    if (values.code.length < 6) {
      return setErrors({ code: t('phone_verif_form.verif_code_required') });
    }

    const res = await validatePhoneNumber({
      phone_number: phone,
      code: values.code.join(''),
    });

    if (res && res.success) {
      onSuccess ? onSuccess() : onClose();
    } else {
      setErrors({ code: res.message });
    }
  };

  if (!phone) {
    return null;
  }

  return (
    <PhoneVerificationForm
      phone={phone}
      captchaToken={captchaToken}
      getCaptchaToken={getCaptchaToken}
      onSubmit={onSubmit}
      className={s.wrapper}
      defaultSubmit
      onBack={onBack}
    />
  );
};

export default PhoneVerificationModal;
